import { render, staticRenderFns } from "./UnitInspectionsPage.vue?vue&type=template&id=1249bdf1&"
import script from "./UnitInspectionsPage.vue?vue&type=script&lang=js&"
export * from "./UnitInspectionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports